import React from 'react';
import { Title, Text, useMantineColorScheme } from '@mantine/core';

interface AdminPageHeaderProps {
  title: string;
  subtitle?: string;
}

const AdminPageHeader: React.FC<AdminPageHeaderProps> = ({ title, subtitle }) => {
  const { colorScheme } = useMantineColorScheme();

  return (
    <div>
      <Title
        order={2}
        size="1.3rem"
        fw={600}
        ta="left"
        style={{
          color: colorScheme === 'dark' ? '#e2e8f0' : '#1e293b',
          fontFamily: 'Space Grotesk, Inter, sans-serif',
          marginBottom: '4px',
        }}
      >
        {title}
      </Title>
      {subtitle && (
        <Text
          size="xs"
          ta="left"
          style={{
            color: colorScheme === 'dark' ? '#94a3b8' : '#64748b',
            fontFamily: 'Inter, sans-serif',
          }}
        >
          {subtitle}
        </Text>
      )}
    </div>
  );
};

export default AdminPageHeader;
